import { jsx as _jsx } from "react/jsx-runtime";
import { TabPanel as ChakraTabPanel } from '@chakra-ui/react';
/**
 * TabPanel Used to render the content for a specific tab.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/tabs
 */
export function TabPanel({ children, ...props }) {
    return _jsx(ChakraTabPanel, { ...props, children: children });
}
//# sourceMappingURL=tabPanel.js.map